import { motion } from "framer-motion";
import React, { useState } from "react";
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import tick from "../../images/tick.gif";

const BarcodeScanner = ({ onScan }) => {
    const [isCameraOpen, setIsCameraOpen] = useState(false);
    const [scannedData, setScannedData] = useState(null);
    const [showSuccess, setShowSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const [isOptionsOpen, setIsOptionsOpen] = useState(false);
    const [isInputOpen, setIsInputOpen] = useState(false);
    const [cardNumber, setCardNumber] = useState("");

    const handleTogglePopUp = (value) => {
        setIsOptionsOpen(value ? value : !isOptionsOpen);
    };
    const handleToggleInputField = (value) => {
        setIsInputOpen(value ? value : !isInputOpen);
    };

    const toggleCamera = () => {
        if (!isCameraOpen) {
            setIsLoading(true); // Start loading spinner
            setIsCameraOpen(true); // Open camera after 2 seconds
            setTimeout(() => {
                setIsLoading(false); // Stop loading spinner
            }, 1000);
        } else {
            setIsCameraOpen(false); // Close camera directly
            setError(""); // Clear any previous errors
            setScannedData(null); // Reset scanned data
            setShowSuccess(false); // Reset success state
            if (onScan) onScan("");
        }
    };

    const handleSuccessfulScan = (result) => {
        navigator.vibrate(25)
        setScannedData(result.text);
        setShowSuccess(true);

        // Close the camera after 2 seconds
        setTimeout(() => {
            setShowSuccess(false);
            setIsCameraOpen(false);
            if (onScan) onScan(result.text); // Pass scanned data to parent
        }, 2000);
    };

    return (
        <div style={{ textAlign: "center", marginTop: "0px" }}>
            <div
                style={{
                    display: "inline-block",
                    padding: "0px",
                    width: "100%",
                    margin: "0",
                    borderRadius: "8px",
                    backgroundColor: "rgba(247, 246, 251, 1)",
                }}
            >
                {!isCameraOpen && !isOptionsOpen && !isInputOpen && (
                    <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 20 }} transition={{ duration: 0.4 }}>
                        <button onClick={handleTogglePopUp} type="button" className="btn btn-link text-black font-size-12 w-100 pb-2" style={{ marginTop: "-1rem" }}>
                            {"Are you already a customer?"}
                        </button>
                    </motion.div>
                )}

                {/* Popup */}
                {isOptionsOpen && (
                    <motion.div
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 20 }}
                        transition={{ duration: 0.4 }}
                        className="d-flex justify-content-center py-3"
                        style={{
                            backgroundColor: "white",
                            padding: "10px",
                            borderRadius: "4px",
                            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                            textAlign: "center",
                            marginBottom: "10px",
                        }}
                    >
                        <div style={{ width: "100%", maxWidth: "600px" }}>
                            <h5
                                style={{
                                    marginBottom: "16px",
                                    fontWeight: "600",
                                    color: "#333",
                                    fontSize: "16px",
                                }}
                            >
                                Choose an Option
                            </h5>
                            <div className="d-flex justify-content-center gap-2 flex-wrap">
                                <button
                                    className="btn btn-primary  bg-wafaa-purple"
                                    style={{
                                        fontSize: "13px",
                                        padding: "6px 10px",
                                        borderRadius: "6px",
                                        flex: "1 1 45%",
                                        minWidth: "140px",
                                    }}
                                    onClick={() => {
                                        setIsOptionsOpen(false);
                                        toggleCamera();
                                    }}
                                >
                                    Scan Your Card
                                </button>
                                <button
                                    className="btn btn-secondary"
                                    style={{
                                        fontSize: "13px",
                                        padding: "6px 10px",
                                        borderRadius: "6px",
                                        flex: "1 1 45%",
                                        minWidth: "140px",
                                    }}
                                    onClick={() => {
                                        setIsOptionsOpen(false);
                                        setScannedData(null); // Reset scan data for manual entry
                                        handleToggleInputField(true);
                                    }}
                                >
                                    Enter Card Number
                                </button>
                            </div>
                        </div>
                    </motion.div>
                )}

                {isInputOpen && !isCameraOpen && !isOptionsOpen && (
                    <motion.div
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 20 }}
                        transition={{ duration: 0.4 }}
                        style={{
                            backgroundColor: "#fff",
                            padding: "10px",
                            borderRadius: "8px",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                            display: "flex",
                            // flexDirection: "column",
                            alignItems: "center",
                            gap: "10px",
                            marginBottom: "10px",
                        }}
                    >
                        {/* Back Button */}
                        <button
                            className="fa-solid fa-xmark"
                            style={{
                                background: "none",
                                border: "none",
                                // color: "#007bff",
                                color: "red",
                                fontSize: "16px",
                                cursor: "pointer",
                                padding: 0,
                                width: "5%",
                            }}
                            onClick={() => {
                                setIsInputOpen(false);
                                setIsOptionsOpen(false);
                            }}
                        >
                            {/* ← */}
                        </button>

                        {/* Input Field with Submit Button Attached */}
                        <div
                            style={{
                                position: "relative",
                                width: "95%",
                            }}
                        >
                            <input
                                type="text"
                                value={cardNumber}
                                onChange={(e) => setCardNumber(e.target.value)}
                                placeholder="Enter your card number"
                                style={{
                                    width: "100%",
                                    // padding: "10px 50px 10px 10px",
                                    padding: "5px 12px",
                                    border: "1px solid #ddd",
                                    borderRadius: "5px",
                                    fontSize: "16px",
                                }}
                            />
                            <button
                                onClick={() => {
                                    if (cardNumber) {
                                        setScannedData(cardNumber);
                                        if (onScan) onScan(cardNumber);
                                    }
                                }}
                                className="fa-solid fa-arrow-right fa-1x  bg-wafaa-purple"
                                style={{
                                    position: "absolute",
                                    top: "50.5%",
                                    right: "0px",
                                    transform: "translateY(-50%)",
                                    // backgroundColor: "#007bff",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "5px",
                                    padding: "10px 20px",
                                    fontSize: "14px",
                                    cursor: "pointer",
                                }}
                            >
                                {/* Submit */}
                            </button>
                        </div>
                    </motion.div>
                )}

                {isCameraOpen && (
                    <motion.div
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 20 }}
                        transition={{ duration: 0.4 }}
                        className="d-flex justify-content-center"
                        style={{
                            position: "relative",
                            backgroundColor: "white",
                            padding: "5px 10px",
                            borderRadius: "4px",
                            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                            textAlign: "center",
                            marginBottom: "10px",
                        }}
                    >
                        {/* Camera Feed */}
                        <div style={{ position: "relative", width: "100%" }}>
                            <BarcodeScannerComponent
                                width={"100%"}
                                height={"100%"}
                                onUpdate={(err, result) => {
                                    if (err) {
                                        setError("Error scanning barcode");
                                        console.error(err);
                                        return;
                                    }
                                    if (result) {
                                        handleSuccessfulScan(result);
                                    }
                                }}
                            />

                            {/* Scanning Animation */}
                            {!isLoading && (
                                <div
                                    style={{
                                        display: showSuccess ? "none" : "block",
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        width: "100%",
                                        height: "100%", // Adjust height to cover most of the container
                                        background: "transparent",
                                        pointerEvents: "none",
                                        zIndex: 2,
                                        transform: "translate(-50%, -50%)", // Centers the grid
                                        overflow: "hidden",
                                    }}
                                >
                                    {/* Grid Lines Animation using Borders */}
                                    <div
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            display: "grid",
                                            gridTemplateColumns: "repeat(auto-fill, minmax(5px, 1fr))", // Creates vertical lines with 5px width
                                            gridTemplateRows: "repeat(auto-fill, minmax(5px, 1fr))", // Creates horizontal lines with 5px height
                                            zIndex: 2,
                                            animation: "scan-animation 2s linear infinite",
                                        }}
                                    >
                                        {/* Create grid lines using divs */}
                                        {[...Array(1000)].map((_, index) => (
                                            <div
                                                key={index}
                                                style={{
                                                    borderTop: "2px solid rgba(0, 255, 0, 0.3)", // Horizontal lines
                                                    borderLeft: "2px solid rgba(0, 255, 0, 0.3)", // Vertical lines
                                                    opacity: "0.5",
                                                    animation: "fade-opacity 2s ease-in-out infinite", // Gradual opacity animation
                                                }}
                                            />
                                        ))}
                                    </div>
                                </div>
                            )}

                            {/* Success Tick Icon Overlay */}
                            {showSuccess && (
                                <div
                                    style={{
                                        position: "absolute",
                                        top: "0",
                                        left: "0",
                                        width: "100%",
                                        height: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        backgroundColor: "rgba(255, 255, 255, 0.8)", // Semi-transparent overlay
                                        zIndex: 3,
                                        animation: "fade-in 1s ease-out forwards",
                                    }}
                                >
                                    <img src={tick} alt="" width={"100%"} height={"100%"} />
                                </div>
                            )}
                        </div>

                        {/* Cancel Icon at the Top-Right Corner */}
                        <div
                            onClick={toggleCamera}
                            className="fa-solid fa-xmark"
                            style={{
                                position: "absolute",
                                top: "9px",
                                right: "10px",
                                // backgroundColor: "rgba(255, 255, 255, 0.7)",
                                color: "red",
                                fontSize: "22px",
                                borderRadius: "50%",
                                padding: "5px 8px",
                                cursor: "pointer",
                                zIndex: 4,
                            }}
                        ></div>
                    </motion.div>
                )}
            </div>
        </div>
    );
};

export default BarcodeScanner;
